import type { HiddenField } from '@/components/gateway-forms/types';
import type { RadioInputProps } from '@/components/radio-group/types';
import type { SelectInputProps } from '@/components/select/types';

export const buildInitialValues = (
  hiddenFields: HiddenField[] = [],
  defaultValues: Record<string, any>,
  radioGroups: RadioInputProps[] = [],
  select: SelectInputProps[] = [],
  textInputs: Array<{ name?: string }> = [],
) => ({
  ...defaultValues,
  ...Object.fromEntries(hiddenFields.map((f) => [f.key, f.value])),
  ...Object.fromEntries(radioGroups.map((g) => [g.name, ''])),
  ...Object.fromEntries(select.map((s) => [s.name, ''])),
  ...Object.fromEntries(textInputs.map((i) => [i.name ?? '', ''])),
});
